import _ from 'underscore';

import {
  componentsConfig,
} from '@bingads-webui-campaign-react/smart-component-util';

export const SmartPageTemplate = {
  Default: 'Default',
  Professional: 'Professional',
};

const requiredComponentList = _.filter(componentsConfig, item => (item.required));

export const TemplateComponentListMapping = {
  [SmartPageTemplate.Default]: requiredComponentList,

  [SmartPageTemplate.Professional]: _.uniq([
    ...requiredComponentList,
    componentsConfig.businessHours,
    componentsConfig.callToAction,
    componentsConfig.professionalService,
    componentsConfig.review,
    componentsConfig.summary,
  ], config => config.type),
};
